import type { FeedbackMessages } from './en';

const am: FeedbackMessages = {
  qualified: {
    title: 'ይህንን ጥናት ስላጠናቀቁ እናመስግናለን!',
    text: 'የአሳሽ መስኮቱን መዝጋት ይችላሉ።\n\nበቅርቡ እርስዎን መልሰን እናይ እንደሆነ እናምናለን።',
  },
  quotaFull: {
    title: 'ይህ ጥናት ተዘግቷል',
    text: 'በጥናታችን ላይ ላሳዩት ፍላጎት እናመስግናለን።\n\nይሁን እንጂ የሚያስፈልጉንን ምላሾች በሙሉ አስቀድመን ተቀብለናል።\n\nበሚመጡት ጥናቶቻችን ውስጥ እርስዎን ማየት እንፈልጋለን!',
  },
  terminated: {
    title: 'አስተያየትዎን ስላጋሩ እናመስግናለን!',
    text: 'በሚመጡት ጥናቶቻችን ውስጥ በቅርቡ እርስዎን ማየት እንፈልጋለን። እስከዚያ ድረስ፣ መልካም ቀን እንመኝልዎታለን።\n\nእባክዎ የአሳሽ መስኮቱን ይዝጉ።',
  },
  mismatch: {
    title: 'ላሳዩት ፍላጎት እናመስግናለን',
    text: 'እርስዎ በሚያሳዝን ሁኔታ ለዚህ የተለየ ጥናት ዒላማ ቡድን አካል አይደሉም።\n\nይህንን ገጽ መዝጋት ይችላሉ።',
  },
  error: {
    title: 'ጥያቄዎን ማስተናገድ አልቻልንም',
    linkProblemDetailed:
      'የተከተሉት አገናኝ ችግር እያጋጠመው ነው። በአድራሻ መስመሩ ላይ ያለው አገናኝ ከተሰጠዎት ጋር የሚመሳሰል መሆኑን ያረጋግጡና እንደገና ይሞክሩ።',
    linkProblemGeneric:
      'የተከተሉት አገናኝ ችግር እያጋጠመው ነው። እባክዎ እንደገና ይሞክሩ።',
    contactPerson:
      'ችግሩ ከቀጠለ፣ እባክዎ አገናኙን ካገኙበት ሰው ይህንን ችግር ያሳውቁ።',
  },
};

export default am;
